import React, { useState } from 'react'
import styled from 'styled-components'
import { TextSubHeading, TextBody, Link, NotificationBadge, IconClose } from 'blocket-ui'
import { withDevice, mediaQueries } from '@blazar-plugins/device'
import staticFilesUrl from 'utils/staticFilesUrl'

const Wrapper = styled.div`
  background-color: #f0f5fb;
  width: 100%;
  display: ${({ hide }) => (!hide ? 'flex' : 'none')};
  align-items: center;
  @media ${mediaQueries.medium} {
    align-items: center;
    border: 1px solid #dfdede;
    margin-top: 16px;
  }
`
const ContentWrapper = styled.div`
  padding: 16px;
  align-self: center;
  font-size: 15px;
  line-height: 1.4;
  @media ${mediaQueries.medium} {
    font-size: 17px;
  }
`
const StyledLink = styled(Link)`
  font-size: inherit;
`

const NoWrapWrapper = styled.span`
  white-space: nowrap;
`
const StyledNotificationBadge = styled(NotificationBadge)`
  display: inline-block;
  margin-left: 8px;
`

const StyledTextBody = styled(TextBody)`
  margin: 4px 0;
  font-size: inherit;
  line-height: inherit;
`

const StyledTextSubHeading = styled(TextSubHeading)`
  line-height: inherit;
`

const ImageWrapper = styled.div`
  padding: 12px;
  text-align: right;
  flex-grow: 1;
  margin: 0;
  min-width: 80px;
  @media ${mediaQueries.medium} {
    padding: 0;
    margin: 6px 16px 0 16px;
  }
`

const StyledImage = styled.img`
  max-width: 100%;
  max-height: 90px;
  display: inline-block;
  vertical-align: center;
  @media ${mediaQueries.medium} {
    max-height: none;
    padding: 0;
  }
`
const IconWrapper = styled.div`
  align-self: center;
  margin-right: 6px;
`

const EducationPlacement = () => {
  const [hide, setHide] = useState(false)
  const onClick = () => setHide(true)
  return (
    <Wrapper hide={hide}>
      <ContentWrapper>
        <StyledTextSubHeading tagName="h3">
          Letar du utbildning, kurser eller{' '}
          <NoWrapWrapper>
            program?
            <StyledNotificationBadge content="Nyhet" />
          </NoWrapWrapper>
        </StyledTextSubHeading>

        <StyledTextBody tagName="p">
          Vi har samlat alla utbildningar på samma ställe!
        </StyledTextBody>
        <StyledLink
          external
          to="https://utbildning.blocket.se"
          target="_blank"
          rel="nofollow noopener noreferrer"
        >
          Blocket utbildning
        </StyledLink>
      </ContentWrapper>
      <ImageWrapper>
        <StyledImage
          src={`${staticFilesUrl}assets/images/blocket-utbildning-logo.svg`}
          alt="Blocket Utbildning Banner"
        />
      </ImageWrapper>
      <IconWrapper onClick={onClick}>
        <IconClose width={20} height={20} />
      </IconWrapper>
    </Wrapper>
  )
}

export default withDevice(EducationPlacement)
